import { render } from "./AddCategoriePPage.vue?vue&type=template&id=067c5fc6&ts=true"
import script from "./AddCategoriePPage.vue?vue&type=script&lang=ts"
export * from "./AddCategoriePPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__